import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/workspaceDeveloper/useWorkspaceDeveloperQueryKeys.ts
var t = e("workspace-developer", {
	status: () => ["status"],
	terms: () => ["terms"],
	keys: (e) => e === void 0 ? ["keys"] : ["keys", e],
	webhookEndpoint: (e) => e === void 0 ? ["webhook-endpoint"] : ["webhook-endpoint", e],
	deliveries: (e) => e === void 0 ? ["deliveries"] : ["deliveries", e],
	deliveryLog: (e) => e === void 0 ? ["delivery-log"] : ["delivery-log", e],
	deliveryStats: (e) => e === void 0 ? ["delivery-stats"] : ["delivery-stats", e],
	requestSeries: (e) => e === void 0 ? ["request-series"] : ["request-series", e],
	requests: (e) => e === void 0 ? ["requests"] : ["requests", e],
	requestLog: (e) => e === void 0 ? ["request-log"] : ["request-log", e],
	requestStats: (e) => e === void 0 ? ["request-stats"] : ["request-stats", e],
	request: (e) => e === void 0 ? ["request"] : ["request", e],
	delivery: (e) => e === void 0 ? ["delivery"] : ["delivery", e]
});
//#endregion
export { t as workspaceDeveloperQueryKeys };
